import Counter from "./Counter";

export const ITEMS = [
  "Sofá", "Cama", "Guarda-roupa", "Mesa", "Cadeiras", "Geladeira", "Freezer",
  "Fogão", "Máquina de lavar", "Micro-ondas", "Televisão", "Rack", "Armário",
  "Estante", "Cômoda", "Colchão", "Caixas", "Bicicleta", "Piano", "Cofre",
];

export default function ItemSelector({ items, onChange, outrosItens, onOutrosChange }) {
  const setQty = (name, qty) => {
    const next = { ...items };
    if (qty <= 0) delete next[name];
    else next[name] = qty;
    onChange(next);
  };

  return (
    <div>
      <div className="grid grid-cols-1 gap-2">
        {ITEMS.map((name) => {
          const qty = items[name] || 0;
          return (
            <div
              key={name}
              data-testid={`item-row-${name.toLowerCase().replace(/\s+/g, "-")}`}
              className={`flex items-center justify-between px-4 py-2.5 rounded-xl border transition ${
                qty > 0 ? "bg-gold-light border-[#F5B301]" : "bg-white border-slate-200"
              }`}
            >
              <span className={`text-sm font-medium ${qty > 0 ? "text-navy" : "text-slate-600"}`}>{name}</span>
              <Counter value={qty} onChange={(v) => setQty(name, v)} testId={`item-${name.toLowerCase().replace(/\s+/g, "-")}`} />
            </div>
          );
        })}
      </div>

      <div className="mt-4">
        <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Outros itens</label>
        <textarea
          data-testid="outros-itens-input"
          className="mt-1 w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#F5B301] placeholder:text-slate-400 min-h-[80px]"
          placeholder="Digite outros itens que serão transportados."
          value={outrosItens}
          onChange={(e) => onOutrosChange(e.target.value)}
        />
      </div>
    </div>
  );
}
